export let symbol = {
    type: "simple-fill",
    color: [0, 0, 0, 0],
    style: "none",
    outline: {  // autocasts as new SimpleLineSymbol()
      color: '#F2893A',
      width: "3px"
    }
  };
  
export let pointSymbol = {
    type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
    style: "x",
    color: "blue",
    size: "8px",  // pixels
    outline: {  // autocasts as new SimpleLineSymbol()
      color: '#F2893A',
      width: 3  // points
    }
};
  
  
  